<template>
  <el-dialog title="证照扫描件" :visible="visible" width="70vw" append-to-body :modal="false" @close="$emit('close');$emit('update:visible',false)">
    <img :src="url" id="print">
    <el-row v-if="!mobile" type="flex" slot="footer" justify="space-around">
      <el-button @click="printHandler" type="warning">打印扫描件</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import printjs from "print-js";
import { mapGetters } from "vuex";
export default {
  name: "printScan",
  computed: {
    ...mapGetters(["token"])
  },
  props: ["scan", "visible", 'mobile'],
  data() {
    return {
      url: ""
    };
  },
  watch: {
    scan: function(v) {
      this.url = `/share-foreign/commannex/viewAnnex?path=${v}&token=${
        this.token
      }`;
    }
  },
  methods: {
    printHandler() {
      printjs({ printable: "print", type: "html",scanStyles: false, style:"#print{max-width: 210mm;max-height: 148.5mm}" });
    }
  },
  mounted() {
    this.url = `/share-foreign/commannex/viewAnnex?path=${this.scan}&token=${
      this.token
    }`;
  }
};
</script>
<style lang="scss" scoped>
  #print{
    max-width: 60vw;
  }
</style>